import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';

import { Box } from '@mui/material';
import useAuth from '../../hooks/useAuth';

interface BaseLayoutProps {
  children?: ReactNode;
}

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  return !user ? (
    <Box
      sx={{
        flex: 1,
        height: '100%'
      }}
    >
      {children || <Outlet />}
    </Box>
  ) : (
    // <></>
    <Navigate to="/dashboard" replace />
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node
};

export default BaseLayout;
